var _excluded = ["className", "children", "withGradient"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useRef } from 'react';
import c from 'classnames';
import Picture from '../Picture';
import './style.scss';
var ImageBackground = function ImageBackground(_ref) {
  var className = _ref.className,
    children = _ref.children,
    withGradient = _ref.withGradient,
    props = _objectWithoutProperties(_ref, _excluded);
  var bgElem = useRef(null);
  var imgElement = useRef(null);
  var onLoad = function onLoad(e) {
    var src = typeof imgElement.current.currentSrc !== 'undefined' ? imgElement.current.currentSrc : imgElement.current.src;
    if (withGradient) {
      bgElem.current.style.backgroundImage = "".concat(withGradient, ", url(\"").concat(src, "\")");
    } else {
      bgElem.current.style.backgroundImage = "url(\"".concat(src, "\")");
    }
  };
  var classes = c('ImageBackground', className);
  return /*#__PURE__*/React.createElement("div", {
    className: classes,
    "data-responsive-background-image": true,
    ref: bgElem
  }, /*#__PURE__*/React.createElement(Picture, _extends({
    className: "ImageBackground__picture",
    onLoadFunction: function onLoadFunction(e) {
      return onLoad(e);
    },
    imageRef: imgElement
  }, props)), children);
};
export default ImageBackground;